import React, { useEffect, useState } from 'react';
import { Hidden, VStack, Box } from 'native-base';
import { get, orderBy } from 'lodash';
import { EmptyBoxIcon, MuiTable, Typography, logUserEvent, colors } from 'fmc-digital-common';
import { TableData } from '../../../utils/Data/TableData';
import { amplifyLogs } from '../../../amplifyLogs';
import { Tasks, TableTitle, MuiTableRow } from '../../molecules';
import { dynamicFilterLabel, getFilteredList, getInitialFliterValue, getTaskCount, setFilterValue } from '../../../loaninprogress/utils';
export default (({
  tableData
}) => {
  const [order, setOrder] = useState('desc');
  const [orderListBy, setOrderListBy] = useState('taskStatus');
  let initialfilter = getInitialFliterValue(tableData);
  const [filteredList, setFilterdList] = useState(initialfilter === 'To Do' ? getFilteredList('To Do', tableData) : tableData);
  const [selectedFilter, setSelectedFilter] = useState(initialfilter ? initialfilter : '');
  useEffect(() => {
    const filteredData = getFilteredList(selectedFilter, tableData);
    setFilterdList(filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);
  const handleTableSort = id => {
    logUserEvent(amplifyLogs[id]);
    const isAsc = id !== orderListBy || orderListBy === id && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderListBy(id);
    //@ts-ignore
    const sortedData = orderBy(filteredList, [`${orderListBy}`], [`${order}`]);
    setFilterdList(sortedData);
  };
  const getSelectedFilter = value => {
    setSelectedFilter(value);
    const filteredData = setFilterValue(value, tableData);
    setFilterdList(filteredData);
  };
  const customLabel = dynamicFilterLabel(tableData);
  const [selectedCard, setSelectedCard] = useState(false);
  const handleToggle = (value, docTableName) => {
    logUserEvent({
      ...amplifyLogs.uploadedDoc,
      description: `${amplifyLogs.uploadedDoc.description}${docTableName}`
    });
    setSelectedCard(prev => {
      return prev === value ? false : value;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hidden, {
    till: "lg"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableTitle, {
    title: "Tasks",
    filterText: "Filter By",
    getSelectedFilter: getSelectedFilter,
    initialFilter: initialfilter,
    taskCount: getTaskCount(filteredList, selectedFilter),
    dynamicFilterLabel: customLabel
  }), /*#__PURE__*/React.createElement(Box, {
    zIndex: -1,
    overflow: 'visible'
  }, /*#__PURE__*/React.createElement(MuiTable, {
    tableHeadList: TableData.tableHeadList,
    handleTableSort: handleTableSort,
    orderListBy: orderListBy,
    order: order
  }, filteredList.map((taskTableData, index) => /*#__PURE__*/React.createElement(MuiTableRow, {
    key: index,
    taskTableData: taskTableData,
    bgColor: selectedCard === index ? get(colors, 'lightBlue.200', '') : index % 2 === 0 ? get(colors, 'white.500', '') : get(colors, 'white.800', ''),
    selectedCard: selectedCard,
    handleToggle: handleToggle,
    index: index
  })))), filteredList.length < 1 ? /*#__PURE__*/React.createElement(Box, {
    width: '100%',
    height: 500,
    paddingTop: 24,
    zIndex: -1,
    overflow: 'visible'
  }, /*#__PURE__*/React.createElement(VStack, {
    space: 2,
    alignItems: 'center',
    justifyItems: 'center'
  }, /*#__PURE__*/React.createElement(EmptyBoxIcon, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "title2",
    color: "darkGray.900",
    accessibilityLabel: "NoTasks",
    accessibilityRole: "text",
    testID: "NoTasks"
  }, `You have no tasks ${selectedFilter.toLowerCase()}.`))) : /*#__PURE__*/React.createElement(React.Fragment, null))), /*#__PURE__*/React.createElement(Hidden, {
    from: "lg"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    zIndex: -1,
    overflow: 'visible'
  }, /*#__PURE__*/React.createElement(Tasks, {
    listData: tableData,
    selectedCard: selectedCard,
    handleToggle: handleToggle
  })))));
});
//# sourceMappingURL=index.js.map